import { Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useQsFilters } from "../../hooks/filters"
import { FiltersBase } from "../../types"
import { TableGruppiDiRicerca } from "./TableGruppiDiRicerca"
import { useNavigate } from "react-router-dom"
import { useGruppiDiRicerca } from "../../hooks/gruppi-di-ricerca"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "nome",
  } as FiltersBase)

export default function GruppiDiRicerca() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useGruppiDiRicerca({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  useBreadcrumbs([{ label: "Gruppo di ricerca" }])

  const navigate = useNavigate()

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>
            Gruppo di ricerca
          </H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/gruppi-di-ricerca/gruppi-di-ricerca/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value })
            }}
          />
        </Flex>
        <TableGruppiDiRicerca
          gruppiDiRicerca={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
